export enum LiSnType {
	SEARCH = "SEARCH",
	SPECIFIC = "SPECIFIC",
}
